<template>
  <keep-alive>
    <router-view/>
  </keep-alive>
</template>

<script>
export default {
  name: 'Schema'
}
</script>

<style scoped>

</style>